import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
} from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Data } from "./../../shared/data";
import { NextaSelectionBaseList } from "./../../shared/nexta-crud/nexta-selection-base-list";
import { NotificationService } from "../../shared/notification.service";
import { Certificate } from "./certificate";
import { CertificateService } from "./crud.service";

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: "app-certificate-list",
	templateUrl: "./certificate-list.component.html",
	standalone: false,
})
export class CertificateListComponent extends NextaSelectionBaseList<Certificate> {
	constructor(
		router: Router,
		certificateService: CertificateService,
		notificationService: NotificationService,
		route: ActivatedRoute,
		acrossPagesData: Data,
		fb: UntypedFormBuilder,
		cdr: ChangeDetectorRef,
	) {
		super(
			"zertifikate",
			router,
			certificateService,
			notificationService,
			route,
			acrossPagesData,
			"certificates",
			cdr,
			fb,
		);
	}
}
